export const GET_VCGS = `
  query vcgs(
    $skip: Int
    $take: Int
    $filter: FilterVcgInput
    $orderBy: VcgOrderInput
    $searchText: String
  ) {
    vcgs(
      skip: $skip
      take: $take
      filter: $filter
      orderBy: $orderBy
      searchText: $searchText
    ) {
      __typename
      ... on Vcg {
        id
        vcg
        observations
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
    totalVcgs(filter: $filter, searchText: $searchText)
  }
`;

export const GET_VCG = `
  query vcg($id: Int!) {
    vcg(id: $id) {
      __typename
      ... on Vcg {
        id
        vcg
        observations
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
